import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
import { moduleName, RitualsState } from './types';

export * from './types';

export function ritualsGetter(getter: string) {
  return `${moduleName}/${getter}`;
}

export const initialState: RitualsState = {
  rituals: {
    items: [],
    meta: {
      currentPage: 0,
      totalPages: 0,
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 0,
    },
  },
  current: undefined,
};

export const ritualsModule: Module<RitualsState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};

export default ritualsModule;
